export default {
  addButton: 'Register',
  onCompleted: {
    title: 'Success',
    message: 'Your account was created.',
    path: '/login'
  },
  passwordsNotMatch: '*The passwords do not match'
}